import { render, staticRenderFns } from "./ContainerConfiguration.vue?vue&type=template&id=48b92478&"
import script from "./ContainerConfiguration.vue?vue&type=script&lang=js&"
export * from "./ContainerConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports